export enum ReduxCommonType {
  SET_COUNTRIES = 'SET_COUNTRIES'
}
